import { createEvent, createStore, merge, sample } from 'effector';
import { DEFAULT_INIT_TABLE_STATE_PAGING, PAGING_LIMIT_DEFAULT_OPTIONS } from '../consts';
import { IDataTableState } from '../models';
import { changeOrderingEvent, changeOrderingReducer } from './events/changeOrderingEvent';
import { changePagingLimitEvent, changePagingLimitReducer } from './events/changePagingLimitEvent';
import { changePagingMoveEvent, changePagingMoveReducer } from './events/changePagingMoveEvent';
import { initStateEvent, initStateReducer } from './events/initStateEvent';
import {
  setDefaultPagingEvent,
  setDefaultPagingEventReducer,
} from '@src/molecules/DataTable/store/events/setDefaultPagingEvent';
import { changePageEvent, changePagingReducer } from '@src/molecules/DataTable/store/events/changePageEvent';

type TOnChangeCallback = ((state: IDataTableState) => void) | null;
export const setOnChangeCallbackEvent = createEvent<TOnChangeCallback>();
export const $onChangeCallbackStore = createStore<TOnChangeCallback>(null);
$onChangeCallbackStore.on(setOnChangeCallbackEvent, (_, payload) => payload);

export const $tableStore = createStore<IDataTableState>({
  paging: { ...DEFAULT_INIT_TABLE_STATE_PAGING },
  ordering: [],
  pagingOptions: PAGING_LIMIT_DEFAULT_OPTIONS,
});

$tableStore
  .on(initStateEvent, initStateReducer)
  .on(changeOrderingEvent, changeOrderingReducer)
  .on(changePagingLimitEvent, changePagingLimitReducer)
  .on(changePagingMoveEvent, changePagingMoveReducer)
  .on(setDefaultPagingEvent, setDefaultPagingEventReducer)
  .on(changePageEvent, changePagingReducer);

/** Список евентов на которые будет отрабатывать onChange  */
const onChangeEvents = merge([changeOrderingEvent, changePagingLimitEvent, changePagingMoveEvent, changePageEvent]);

sample({
  source: [$onChangeCallbackStore, $tableStore],
  clock: onChangeEvents,
  fn: ([onChangeFn, tableStoreData]) => {
    (onChangeFn as TOnChangeCallback)?.(tableStoreData as IDataTableState);
  },
});
